// @flow

import React from 'react'
import $ from 'jquery'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { reset, change } from 'redux-form'
import { Map } from 'immutable'
import bindAll from "lodash/bindAll";
import UserRegisterWizardFormFirstPageNew from './users/UserRegisterWizardFormFirstPageNew'
import UserRegisterWizardFormThirdPageNew from './users/UserRegisterWizardFormThirdPageNew'
import initializers from '../../dependencies/initializers'
import { usersAddNavigationPage } from '../../actions/users'
import { translate } from '../../helpers/global'

import HeaderNewClear from '../partials/HeaderNewClear.jsx'
import FooterNew from '../partials/FooterNew.jsx'

import imgOfficeGirl from '../../styles/img/office-girl.svg'


type Props = {
	resetForm: Function,
	usersAddNavigationPage: Function,
	usersNavigationData: Map<string, any>
};

type State = {
	unblockTransition: Function,
	cachedUsersNavigationDataPage: string,
	nextPage: Function,
	prevPage: Function
};


class UserRegisterWizardFormContainerNew extends React.Component<Props, State> {
	constructor(props) {
		super(props)

		this.state = {
			unblockTransition: () => {},
			cachedUsersNavigationDataPage: '',
			nextPage: () => {},
			prevPage: () => {},
		}

		bindAll(this, []);
	}

	componentDidMount() {
		const titleElement: Object = document.getElementsByTagName('title')

		titleElement[0].text = 'ASTRNT'
		window.scrollTo(0, 0);
	    
	    $('.overlay, .close-button').click(function(event){
	        event.preventDefault();
	        
	        $('#pop-1').slideUp('fast');
	        $('#pop-2').slideUp('fast');
	        $('.overlay').fadeOut('fast');
	    });

		if('ngo' === this.props.plan) {
	  	  $('#how-do-you-hope').css('display', 'list-item')
		}
	}

	componentWillUnmount() {
		// this.state.unblockTransition()
		const {
			resetForm,
			usersAddNavigationPage
		} = this.props

		resetForm('UserRegisterWizardForm')
		usersAddNavigationPage(1)
	}

	handleLoginLink(e: Object): void {
		e.preventDefault()
			window.location = initializers.recruiter_host+'/auth/login'
	}

	static getDerivedStateFromProps(nextProps, prevState) {
		const {
			usersNavigationData,
			usersAddNavigationPage,
			url_location,
			history
		} = nextProps

		if (usersNavigationData.get('page') !== prevState.cachedUsersNavigationDataPage) {
			let page: number = usersNavigationData.get('page')

			const nextPage: Function = () => {
				usersAddNavigationPage(page + 1)
			}

			const previousPage: Function = () => {
				usersAddNavigationPage(page - 1)
			}

			switch(page) {
				case 2:
					// history.push('/registered')
					window.dataLayer.push({
						event: 'registered',
						page: {
						  url: url_location,
						  title: 'registered success'
						}
					  });
					return {
						cachedUsersNavigationDataPage: page,
					}
				default:
					return {
						cachedUsersNavigationDataPage: page,
						prevPage: previousPage,
						nextPage: nextPage,
					}
			}
		}

		return null
	}


	render() {
		const {
			globalGetLanguages,
		} = this.props

		return (
			<div id="register">
	        <HeaderNewClear />
	        <div className="pad-top desktop-hide" />
	        <section className="sec-reg">
	          <ul className="lay-reg">
	            <li>
	              <div className="desc-log">
	                <span>Start using ASTRNT Platform today.<br/>No credit card, no commitment.</span>
	                Get free credits instantly in your Free Plan account and explore how we can support your hiring, talent, or admissions goals.
	                <ul>
	                  <li><i className="fas fa-check" />Unlimited jobs and programs</li>
	                  <li><i className="fas fa-check" />Free candidate tracking, always</li>
	                  <li><i className="fas fa-check" />Add as many team members as you need</li>
	                  <li><i className="fas fa-check" />Built-in assessment & interview tools</li>
	                  <li><i className="fas fa-check" />Talk anytime with our expert support team</li>
	                </ul>
	                <img src={imgOfficeGirl} />
	              </div>
	            </li>
	            <li>
	              <div className="box-reg">
					{
						this.state.cachedUsersNavigationDataPage == '2' ? 
							<UserRegisterWizardFormThirdPageNew /> 
							: 
							<UserRegisterWizardFormFirstPageNew
								previousPage={this.state.prevPage}
								onSubmit={this.state.nextPage}
								plan={this.props.plan}
							/>
					}
	              </div>
	            </li>
	          </ul>
	        </section>
	        <FooterNew />
	      </div>
    )
	}
}

const mapStateToProps = (state, ownProps) => {
	let plan = 'free' // default plan
	let params = new URLSearchParams(window.location.search)
	let cdcId = '';
	if(ownProps?.location?.search && params.get('plan')) {
		plan = params.get('plan')
	} else if(ownProps?.location?.query?.plan) {
		plan = ownProps.location.query.plan
	}

	if(params && params.get('cdcId')) {
		cdcId = params.get('cdcId');
	}
	
	return {
		usersNavigationData: state.usersNavigationData,
		plan: plan,
		url_location:ownProps.location,
		globalGetLanguages:state.globalGetLanguages,
		cdcId,
	}
}

const mapDispatchToProps = (dispatch) => {
	return {
		resetForm: (formName) => dispatch(reset(formName)),
		usersAddNavigationPage: (page) => dispatch(usersAddNavigationPage(page)),
		changeFieldValue: (field, value) => dispatch(change('UserRegisterWizardForm', field, value, true, true)),
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(UserRegisterWizardFormContainerNew)
